"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsRegisted = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var guMember_1 = require("../../model/guMember");
var service_1 = require("../../../library/base/service");
var IsRegisted = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(IsRegisted, _super);
    function IsRegisted() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '判断用户是否注册登录';
        _this.code = '300401';
        _this.desc = '判断用户是否注册登录';
        _this.requestParams = new guMember_1.IsRegistedRequest();
        _this.method = fetch_1.Methods.GET;
        return _this;
    }
    return IsRegisted;
}(service_1.BaseService));
exports.IsRegisted = IsRegisted;
//# sourceMappingURL=isRegisted.js.map